// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.capturesetup_captureSetupContainer__9O7V- {
  display: flex;
  flex:  5 1;
  flex-direction: column;
  align-items: flex-start;
  align-content: center;
  justify-content: center;
  background-color: var(--hsrcBackgroundLight);
  border-radius: 1rem;
  padding: 2rem;

}

.capturesetup_featuredDropDown__L9g1J {
  flex: 1 1;
  margin: 0px 20px;
  padding: 30px;
  border-radius: 10px;
  cursor:default;
  /* -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75); */
}
 
.capturesetup_featuredItem__4ywqF {
    flex: 1 1;
    margin: 0px 20px;
    padding: 30px;
    border-radius: 10px;
    cursor:default;
    /* -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75); */
  }

    .capturesetup_featuredTitleHeader__CDyFz {
      color: var(--hsrcDarkBlue);
      font-size: 15px;
      font-weight: bold;
    }




  /* Style the modal */
.capturesetup_modal__snqIz {
    position: fixed; /* Stay in place */
    z-index: 1; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    background-color: rgba(0, 0, 0, 0.4); /* Semi-transparent black background */
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  /* Modal Content */
  .capturesetup_modal_content__pPtu4 {
    margin: auto;
    padding: 20px;
    border: 1px solid #888;
    border-radius: 5px;
    display: flex;
    align-items: center;
    box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.2);
    background-color: #fefefe;
  }
  
  .capturesetup_modal_text__JopuV {
    margin-left: 14px;
    font-size: 24px;
  }
  
  /* Create the circle loader with pure CSS */
  .capturesetup_loader__raTWr {
    width: 50px;
    height: 50px;
    border: 8px solid #ddd;
    border-top: 8px solid #2196f3;
    border-bottom: 8px solid #2196f3;
    border-radius: 50%;
    animation: capturesetup_spin__\\+gujw 2s linear infinite;
  }
  
  @keyframes capturesetup_spin__\\+gujw {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }


  .capturesetup_btn_inline__ZHlqv {
    display: inline-block;
    border-radius: 50px;
    background-color: var(--hsrcOrange);
    border-color: var(--hsrcOrange);
    border-style: solid;
    border-width: 1rem;
    color: var(--hsrcWhite);
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    padding-left: 15px;
    padding-right: 15px;
    transition: all 0.5s;
    /* margin: 15px; */
    letter-spacing: 0.15rem;
    cursor: pointer;
    height: 30px;
    width: auto;
  }`, "",{"version":3,"sources":["webpack://./src/pages/ResearcherDashboard/components/CaptureSetup/capturesetup.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,UAAQ;EACR,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,4CAA4C;EAC5C,mBAAmB;EACnB,aAAa;;AAEf;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd;uDACqD;AACvD;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd;yDACqD;EACvD;;IAEE;MACE,0BAA0B;MAC1B,eAAe;MACf,iBAAiB;IACnB;;;;;EAKF,oBAAoB;AACtB;IACI,eAAe,EAAE,kBAAkB;IACnC,UAAU,EAAE,eAAe;IAC3B,OAAO;IACP,MAAM;IACN,WAAW,EAAE,eAAe;IAC5B,YAAY,EAAE,gBAAgB;IAC9B,oCAAoC,EAAE,sCAAsC;IAC5E,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA,kBAAkB;EAClB;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,0CAA0C;IAC1C,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA,2CAA2C;EAC3C;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,6BAA6B;IAC7B,gCAAgC;IAChC,kBAAkB;IAElB,uDAAkC;EACpC;;EAWA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;;;EAGA;IACE,qBAAqB;IACrB,mBAAmB;IACnB,mCAAmC;IACnC,+BAA+B;IAC/B,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,WAAW;EACb","sourcesContent":[".captureSetupContainer {\r\n  display: flex;\r\n  flex:  5;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  align-content: center;\r\n  justify-content: center;\r\n  background-color: var(--hsrcBackgroundLight);\r\n  border-radius: 1rem;\r\n  padding: 2rem;\r\n\r\n}\r\n\r\n.featuredDropDown {\r\n  flex: 1;\r\n  margin: 0px 20px;\r\n  padding: 30px;\r\n  border-radius: 10px;\r\n  cursor:default;\r\n  /* -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n  box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75); */\r\n}\r\n \r\n.featuredItem {\r\n    flex: 1;\r\n    margin: 0px 20px;\r\n    padding: 30px;\r\n    border-radius: 10px;\r\n    cursor:default;\r\n    /* -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75); */\r\n  }\r\n\r\n    .featuredTitleHeader {\r\n      color: var(--hsrcDarkBlue);\r\n      font-size: 15px;\r\n      font-weight: bold;\r\n    }\r\n\r\n\r\n\r\n\r\n  /* Style the modal */\r\n.modal {\r\n    position: fixed; /* Stay in place */\r\n    z-index: 1; /* Sit on top */\r\n    left: 0;\r\n    top: 0;\r\n    width: 100%; /* Full width */\r\n    height: 100%; /* Full height */\r\n    background-color: rgba(0, 0, 0, 0.4); /* Semi-transparent black background */\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  \r\n  /* Modal Content */\r\n  .modal_content {\r\n    margin: auto;\r\n    padding: 20px;\r\n    border: 1px solid #888;\r\n    border-radius: 5px;\r\n    display: flex;\r\n    align-items: center;\r\n    box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.2);\r\n    background-color: #fefefe;\r\n  }\r\n  \r\n  .modal_text {\r\n    margin-left: 14px;\r\n    font-size: 24px;\r\n  }\r\n  \r\n  /* Create the circle loader with pure CSS */\r\n  .loader {\r\n    width: 50px;\r\n    height: 50px;\r\n    border: 8px solid #ddd;\r\n    border-top: 8px solid #2196f3;\r\n    border-bottom: 8px solid #2196f3;\r\n    border-radius: 50%;\r\n    -webkit-animation: spin 2s linear infinite;\r\n    animation: spin 2s linear infinite;\r\n  }\r\n  \r\n  @-webkit-keyframes spin {\r\n    0% {\r\n      -webkit-transform: rotate(0deg);\r\n    }\r\n    100% {\r\n      -webkit-transform: rotate(360deg);\r\n    }\r\n  }\r\n  \r\n  @keyframes spin {\r\n    0% {\r\n      transform: rotate(0deg);\r\n    }\r\n    100% {\r\n      transform: rotate(360deg);\r\n    }\r\n  }\r\n\r\n\r\n  .btn_inline {\r\n    display: inline-block;\r\n    border-radius: 50px;\r\n    background-color: var(--hsrcOrange);\r\n    border-color: var(--hsrcOrange);\r\n    border-style: solid;\r\n    border-width: 1rem;\r\n    color: var(--hsrcWhite);\r\n    text-align: center;\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n    transition: all 0.5s;\r\n    /* margin: 15px; */\r\n    letter-spacing: 0.15rem;\r\n    cursor: pointer;\r\n    height: 30px;\r\n    width: auto;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"captureSetupContainer": `capturesetup_captureSetupContainer__9O7V-`,
	"featuredDropDown": `capturesetup_featuredDropDown__L9g1J`,
	"featuredItem": `capturesetup_featuredItem__4ywqF`,
	"featuredTitleHeader": `capturesetup_featuredTitleHeader__CDyFz`,
	"modal": `capturesetup_modal__snqIz`,
	"modal_content": `capturesetup_modal_content__pPtu4`,
	"modal_text": `capturesetup_modal_text__JopuV`,
	"loader": `capturesetup_loader__raTWr`,
	"spin": `capturesetup_spin__+gujw`,
	"btn_inline": `capturesetup_btn_inline__ZHlqv`
};
export default ___CSS_LOADER_EXPORT___;
